export default [
  { name: 'default_dashboard_filter', type: 'json' },
];



// WEBPACK FOOTER //
// ./src/frontend/modules/settings/user/user-settings.js